export const comboDefActiveStatus = {
    collection: 'active_combo',
    select: 'ID, FieldValue',
    top: '500',
    where: '',
    groupby: '',
    orderby: 'FieldValue',
    with0: 'true',
}
